import KBaseMap from "@/components/Maps/KBaseMap";
import KBaseMapInfoWindow from "../Maps/KBaseMapInfoWindow";
import KBaseMapMarker from "../Maps/KBaseMapMarker";
import {
	VCard,
	VIcon,
	VList,
	VListItem,
	VListItemAction,
	VListItemContent,
	VListItemTitle
} from "vuetify/lib";

export default {
	name: "KAddressMap",

	props: {
		lat: {
			required: true,
			type: Number
		},

		lng: {
			required: true,
			type: Number
		}
	},

	data: () => ( {
		markerType: "address"
	} ),

	computed: {
		storeModuleName() {
			return `address-map-${this.lat}-${this.lng}`;
		},

		markerId() {
			return `${this.lat}-${this.lng}`;
		}
	},

	mounted() {
		this.$store.dispatch( `${this.storeModuleName}/setMapCenter`, {
			lat: this.lat,
			lng: this.lng
		} );

		this.$store.dispatch( `${this.storeModuleName}/setActiveMarker`, {
			id: this.markerId,
			type: this.markerType
		} );
	},

	render() {
		return <KBaseMap storeModuleName={this.storeModuleName}>
			<KBaseMapMarker
				enableGeolocation
				lat={this.lat}
				lng={this.lng}
				markerId={this.markerId}
				markerType={this.markerType}
				scopedSlots={{
					active: props => <KBaseMapInfoWindow showPano>
						<VCard flat light>
							<VList class="list--auto-height" dense>
								<VListItem>
									<VListItemAction>
										<VIcon>place</VIcon>
									</VListItemAction>

									<VListItemContent>
										<VListItemTitle>
											{props.geocoderRunning
												? "Loading..."
												: props.geocodedLocationName
											}
										</VListItemTitle>
									</VListItemContent>
								</VListItem>
							</VList>
						</VCard>
					</KBaseMapInfoWindow>
				}}
			></KBaseMapMarker>
		</KBaseMap>;
	}
};
